import { AdaptedMetricType } from '../monitoringTypes';
import { ViewAsEnum } from '../constants';

/**
 * Filters chart dataSets based on the current View As selection
 * @param chart - The chart data to filter
 * @param viewAs - The current View As selection (AVG, MIN, MAX)
 * @returns Filtered chart with only matching dataSet
 */
export const filterChartByViewAs = (
  chart: AdaptedMetricType,
  viewAs: ViewAsEnum = ViewAsEnum.AVG,
): AdaptedMetricType => {
  if (!chart?.dataSets || !Array.isArray(chart.dataSets)) {
    return chart;
  }

  const filteredDataSets = chart.dataSets.filter((dataset) => {
    if (!dataset?.aggregationType || dataset.aggregationType.trim() === '') {
      return true;
    }
    return dataset?.aggregationType === viewAs;
  });

  return {
    ...chart,
    dataSets: filteredDataSets,
  };
};
